// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__Bk3tO","select":"Header_select__379Fy","clinic":"Header_clinic__sXRQr"};